import cn from 'classnames'

import { ActionButton, DeleteButton, PrimaryButton } from '../Button'

const RowActionItem = ({ children, className, onClick, isDisabled, buttonType }) => {
  let ButtonComponent = null

  switch (buttonType) {
    // biome-ignore lint/suspicious/useDefaultSwitchClauseLast: TODO
    default:
    // biome-ignore lint/complexity/noUselessSwitchCase: TODO
    case 'action':
      ButtonComponent = ActionButton
      break
    case 'primary':
      ButtonComponent = PrimaryButton
      break
    case 'delete':
      ButtonComponent = DeleteButton
      break
  }

  return (
    <ButtonComponent className={cn('rowActionItem', className)} onClick={onClick} disabled={isDisabled}>
      {children}
    </ButtonComponent>
  )
}

RowActionItem.defaultProps = {
  buttonType: 'action',
}

export default RowActionItem
